import { render } from "./UserTreeView.vue?vue&type=template&id=2a918830"
import script from "./UserTreeView.vue?vue&type=script&lang=js"
export * from "./UserTreeView.vue?vue&type=script&lang=js"
script.render = render

export default script